(() => {
  if (customElements.get('atomic-opening-card')) return;
  customElements.define('atomic-opening-card', class extends HTMLElement {
    connectedCallback() {
      const heading = this.querySelector('[data-flow-entered]');
      if (!heading || heading.dataset.flowEntered === 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          heading.dataset.flowEntered = 'true';
          this.observer.disconnect();
        }
      }, { threshold: 0.8 });
      this.observer.observe(heading);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
